var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg"},[_c('common-head',{attrs:{"active":0}}),_c('common-slide'),_c('index-banner'),_c('index-activity'),_c('common-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }